/** is in range (inclusive) */
const isInRange = (value, min, max) => value >= min && value <= max;

export { isInRange };
//# sourceMappingURL=is-in-range.js.map
